import { createContext } from 'react'
import { AuthorizationUseCases } from '../useCase/authorization/authorization';
import { LandingUseCases } from '../useCase/landing/landing';
import { UploadTaskUseCases } from '../useCase/uploadtask/uploadtask';
import { UserUseCases } from '../useCase/users/user';

interface UseCasesContextInterface {
    authUseCase: AuthorizationUseCases;

    landingUseCase: LandingUseCases; 
    uploadtaskUseCase: UploadTaskUseCases;
    userUseCase: UserUseCases;
}

export const UseCasesContext = createContext<UseCasesContextInterface | null>(null)
